import { render, staticRenderFns } from "./TonalBody.vue?vue&type=template&id=2a2b1298&"
import script from "./TonalBody.vue?vue&type=script&lang=js&"
export * from "./TonalBody.vue?vue&type=script&lang=js&"
import style0 from "./TonalBody.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports